import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const ComingSoon = () => {
  const targetDate = new Date(new Date().getTime() + 40 * 24 * 60 * 60 * 1000); // 45 gün sonrası

  function calculateTimeLeft() {
    const now = new Date().getTime();
    const difference = targetDate.getTime() - now;

    return difference > 0
      ? {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        }
      : { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white px-4">
      <div className="relative inline-block">
        <motion.h1
          className="text-5xl sm:text-8xl font-extrabold text-center mb-4 text-transparent bg-clip-text"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={{
            paddingBottom: "25px",
            backgroundImage:
              "linear-gradient(90deg, #ffffff, #e0e0e0, #5a7fa3, #d9d9d9, #ffffff)",

            backgroundSize: "300% 100%",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            animation: "gradientMove 6s linear infinite",
          }}
        >
          Çok Yakında!
        </motion.h1>

        <style>
          {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
        </style>
      </div>
      <motion.p
        className="text-lg sm:text-3xl text-white text-center mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        Yeni platformumuz için hazır olun.
      </motion.p>

      <motion.div
        className="flex space-x-4 text-center text-3xl font-semibold"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        >
        {["Gün", "Saat", "Dakika", "Saniye"].map((unit, index) => (
          <motion.div
            key={unit}
            className="p-4 w-24 bg-gray-800 rounded-lg shadow-lg"
            whileHover={{ scale: 1.1 }}
          >
            <p className="text-5xl font-bold">
              {[timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds][index]}
            </p>
            <span className="text-sm text-gray-400">{unit}</span>
          </motion.div>
        ))}
      </motion.div>

      {/* İletişim Bilgileri */}
      <motion.div
        className="mt-12 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 1 }}
      >
        <motion.a
          href="https://api.whatsapp.com/send?phone=908505320255"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center bg-gray-800 hover:bg-gray-800 px-6 py-4 rounded-lg transition shadow-lg hover:text-white"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="text-lg font-semibold">WhatsApp Destek</span>
        </motion.a>

        <motion.a
          href="mailto:info@deltaservis.com.tr"
          className="flex items-center bg-gray-800 hover:bg-gray-800 px-6 py-4 rounded-lg transition shadow-lg hover:text-white"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="text-lg font-semibold">info@deltaservis.com.tr</span>
        </motion.a>
      </motion.div>
    </div>
  );
};

export default ComingSoon;
